module.exports = __webpack_public_path__ + "img/play.ee61e5e9.svg";